import { Box, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { PropsWithChildren } from 'react';
import { ImageDecorationPosition, ShowIconsOnFocused } from '../types';

const styleImageDecoration = { position: 'absolute', zIndex: 2 };
const styleImageDecorationNonInteractive = { pointerEvents: 'none' };
const styleImageDecorationTopLeft = {
    ...styleImageDecoration,
    top: 0,
    left: 0,
};
const styleImageDecorationTopRight = {
    ...styleImageDecoration,
    top: 0,
    right: 0,
};
const styleImageDecorationBottomLeft = {
    ...styleImageDecoration,
    bottom: 0,
    left: 0,
};
const styleImageDecorationBottomRight = {
    ...styleImageDecoration,
    bottom: 0,
    right: 0,
};

function styleImageDecorationPosition(
    position: ImageDecorationPosition
): SxProps<Theme> {
    switch (position) {
        case ImageDecorationPosition.TopLeft:
            return styleImageDecorationTopLeft;
        case ImageDecorationPosition.TopRight:
            return styleImageDecorationTopRight;
        case ImageDecorationPosition.BottomLeft:
            return styleImageDecorationBottomLeft;
        case ImageDecorationPosition.BottomRight:
            return styleImageDecorationBottomRight;
    }
}

export interface ImageDecorationProps extends PropsWithChildren {
    position: ImageDecorationPosition;
    isInteractive?: boolean;
}
function ImageDecoration({
    position,
    isInteractive = false,
    children,
}: ImageDecorationProps) {
    if (!children) {
        return null;
    }
    return (
        <Box
            sx={sxAppend(
                styleImageDecorationPosition(position),
                !isInteractive && styleImageDecorationNonInteractive
            )}
        >
            {children}
        </Box>
    );
}

export interface ImageDecorationOverlayProps {
    decorations?: ImageDecorationProps[];
    isFocused: boolean;
    showIconsOnFocused?: ShowIconsOnFocused;
}

export function ImageDecorationOverlay({
    decorations = [],
    isFocused,
    showIconsOnFocused = ShowIconsOnFocused.Interactive,
}: ImageDecorationOverlayProps) {
    if (
        !decorations ||
        decorations.length === 0 ||
        (isFocused && showIconsOnFocused === ShowIconsOnFocused.None)
    ) {
        return null;
    }
    return (
        <>
            {decorations.map(({ isInteractive, ...decoration }, index) => {
                if (
                    showIconsOnFocused === ShowIconsOnFocused.Interactive &&
                    isFocused &&
                    !isInteractive
                ) {
                    return null;
                }
                return (
                    <ImageDecoration
                        key={`${decoration.position}-${index}`}
                        isInteractive={isInteractive}
                        {...decoration}
                    />
                );
            })}
        </>
    );
}
